import { StatusIcon } from '../../../icons/SvgIcons';
import { ComplianceStatus } from '../../../types/AISystems.types';
import RiskClassificationComponent from '../../tables/AISystemsTable/components/RiskClassification/RiskClassification';
import { OverviewCardProps } from './OverviewCard.type';

export function OverviewCard({
  title,
  value,
  subtitle,
  variant = 'default',
  progressPercentage,
  badgeText,
  badgeColor = 'gray',
  riskLevel,
  riskText,
  statusText
}: OverviewCardProps) {
  const statusIconKey = statusText?.toUpperCase().replace(' ', '_');

  const renderContent = () => {
    switch (variant) {
      case 'classification':
        if (!riskLevel || !riskText) return null;
        return (
          <div className="flex justify-start">
            <RiskClassificationComponent
              riskType={riskText.toUpperCase().replaceAll('-', '_')}
              className="!text-sm !py-0.5 px-3"
            />
          </div>
        );

      case 'status':
        return (
          <div className="flex items-center gap-2">
            {statusIconKey
              ? StatusIcon(statusIconKey as ComplianceStatus)
              : null}
            <span className="font-inter font-medium text-sm leading-5 text-[#27272A]">
              {statusText}
            </span>
          </div>
        );

      case 'progress':
        return (
          <div className="flex flex-col gap-2">
            <div className="flex items-center gap-2">
              <div className="flex-1 h-2 bg-gray-100 rounded-full overflow-hidden">
                <div
                  className="h-full bg-cyan-200 transition-all duration-300"
                  style={{ width: `${progressPercentage || 0}%` }}
                />
              </div>
              <span className="font-sans font-medium text-sm leading-5 text-gray-550">
                {progressPercentage || 0}%
              </span>
            </div>
          </div>
        );

      case 'badge':
        const badgeColors = {
          red: 'bg-rose-50 text-rose-700',
          orange: 'bg-orange-50 text-orange-700',
          yellow: 'bg-yellow-50 text-yellow-700',
          green: 'bg-cyan-50 text-cyan-700',
          gray: 'bg-gray-100 text-gray-700'
        };

        return (
          <div
            className={`inline-flex px-3 py-1 rounded-md ${badgeColors[badgeColor as keyof typeof badgeColors]}`}
          >
            <span className="font-sans font-medium text-sm leading-5">
              {badgeText}
            </span>
          </div>
        );

      default:
        return (
          <div className="flex items-baseline gap-2">
            <span className="font-sans font-medium text-2xl leading-9 text-gray-900">
              {value}
            </span>
            {subtitle && (
              <span className="font-sans font-medium text-sm leading-5 text-gray-550">
                {subtitle}
              </span>
            )}
          </div>
        );
    }
  };

  return (
    <div
      className={`flex flex-col rounded-lg bg-white p-6 w-full shadow-sm border border-gray-250v2 ${variant === 'status' || variant === 'classification' ? 'gap-3' : 'gap-1'}`}
    >
      {title ? (
        <div className="text-left uppercase text-gray-550 font-sans font-medium text-xs leading-4 tracking-wider">
          {title}
        </div>
      ) : null}
      {renderContent()}
    </div>
  );
}
